import { useState } from "react";
import { useDebounceCallback } from "./use-debounce-callback";

/**
 * Uses debounced state that delays updating the state until after `wait` milliseconds
 * have elapsed since the last time the setter function was invoked.
 */
export function useDebounce(initialState, wait, leading) {
  const [state, setState] = useState(initialState);
  return [state, useDebounceCallback(setState, wait, leading)];
}